import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import BorderlessButton from '../../../common/buttons/BorderlessButton';
import CustomConfirmModal from '../../../common/modals/CustomConfirmModal';

function TableDeleteButton({
  onConfirm,
  title = 'Are you sure you want to delete this row?',
  content,
  okText = 'Yes',
  cancelText = 'No',
  style,
}) {
  const onDeleteClicked = (e) => {
    e.stopPropagation();
    CustomConfirmModal({
      title,
      content,
      onOk: onConfirm,
      okText,
      cancelText,
    });
  };
  return (
    <BorderlessButton
      iconNode={<DeleteOutlined style={{ color: 'red' }} />}
      style={style}
      onClick={onDeleteClicked}
    />
  );
}

TableDeleteButton.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  style: PropTypes.shape({}),
};

TableDeleteButton.defaultProps = {
  title: 'Are you sure you want to delete this row?',
  content: undefined,
  okText: 'Yes',
  cancelText: 'No',
  style: undefined,
};

export default TableDeleteButton;
